import { render, staticRenderFns } from "./LedgerBudget.vue?vue&type=template&id=867cd866&"
import script from "./LedgerBudget.vue?vue&type=script&lang=js&"
export * from "./LedgerBudget.vue?vue&type=script&lang=js&"
import style0 from "./LedgerBudget.vue?vue&type=style&index=0&id=867cd866&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports